<template>
    <img src="/images/promo/hero-section/index-pointing-at-you.png"
     alt="Index pointing at you" />
</template>

<script>
export default {};
</script>
